import { useEventDataOfSelectedEvent } from "@Utils/event";
import { LISTING_TYPES } from "repoV2/constants/listing";

/**
 * @description use this hook in old event page to decide whether to show or hide the `ScheduleSelector` component
 */
export const useHideScheduleSelector = () => {
    const {
        eventData: { type: eventType },
    } = useEventDataOfSelectedEvent();

    return [
        LISTING_TYPES.NO_SCHEDULE,
        LISTING_TYPES.RECORDED_CONTENT,
        LISTING_TYPES.WHATSAPP,
        LISTING_TYPES.BRANDED_COMMUNITY,
        LISTING_TYPES.TELEGRAM,
    ].includes(eventType);
};
